<template>
  <v-row justify="center">
    <v-dialog
      v-model="isVisible"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="800"
      persistent
      scrollable
    >
      <v-card>
        <v-toolbar
          flat
          height="80"
          max-height="80"
        >
          <v-avatar>
            <v-icon
              color="brand-primary"
              x-large
            >
              mdi-crosshairs-gps
            </v-icon>
          </v-avatar>

          <v-toolbar-title class="pl-3">
            {{ $t('Account.Addresses.Button.Select.Title') }}
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            class="grey lighten-3 ma-0"
            color="black"
            icon
            @click="closeDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider />

        <v-card-text class="pa-lg-4 pa-2">
          <v-list two-line>
            <template v-for="address in user.Addresses">
              <v-list-item
                :key="`address-${address.Id}`"
                ripple
                @click.stop="onSelectAddressClick(address)"
              >
                <v-list-item-avatar class="hidden-xs-only">
                  <v-icon
                    :class="[address.IsDefault ? 'success' : 'grey lighten-2']"
                    class="white--text"
                    large
                  >
                    mdi-check
                  </v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="text-left">
                    <v-chip
                      v-if="address.Nickname"
                      class="px-2"
                      color="pink"
                      label
                      small
                      text-color="white"
                    >
                      {{ address.Nickname }}
                    </v-chip>

                    {{ getAddressFormatted(address) }}
                  </v-list-item-title>

                  <v-list-item-subtitle v-if="address.Floor || address.DoorBell">
                    <span
                      v-if="address.Floor"
                      class="mr-3"
                    >
                      <strong>{{ $t('Account.Addresses.Floor') }}:</strong> {{ address.Floor }}
                    </span>

                    <span v-if="address.DoorBell">
                      <strong>{{ $t('Account.Addresses.DoorBell') }}:</strong> {{ address.DoorBell }}
                    </span>
                  </v-list-item-subtitle>

                  <v-list-item-subtitle v-if="address.Comment">
                    <strong>{{ $t('Account.Addresses.Comment') }}:</strong> {{ address.Comment }}
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action class="hidden-xs-only">
                  <v-icon class="success--text">
                    mdi-crosshairs-gps
                  </v-icon>
                </v-list-item-action>
              </v-list-item>

              <v-divider :key="`address-divider-${address.Id}`" />
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

import AccountSelectAddressDialogMixin from '@/theme/default/components/account/AccountSelectAddressDialog.js'

export default {
  name  : 'AccountSelectAddressDialog',
  mixins: [AccountSelectAddressDialogMixin]
}
</script>

<style scoped src="@/theme/default/components/account/AccountSelectAddressDialog.css"></style>

<style scoped>
</style>
